import { useStore } from "../state/store";
import { ui } from "../state/app";
import { Sheet } from "./Sheet";

export function ConfirmDialog() {
  const req = useStore(ui, (s) => s.confirm);
  const done = (ok: boolean) => {
    req?.resolve(ok);
    ui.set({ confirm: null });
  };
  return (
    <Sheet open={!!req} onClose={() => done(false)} title={req?.title ?? ""} size="auto" class="confirm-sheet">
      {req && (
        <div class="confirm">
          {req.body && <p class="confirm-body">{req.body}</p>}
          <div class="row-gap confirm-actions">
            <button class="btn btn-grow" onClick={() => done(false)}>
              Keep it
            </button>
            <button class={`btn btn-grow ${req.danger ? "btn-danger" : "btn-primary"}`} onClick={() => done(true)}>
              {req.ok}
            </button>
          </div>
        </div>
      )}
    </Sheet>
  );
}
